import React from "react";
import { BgPattern } from "@/assets/images";

type IProps = {
  children: React.ReactNode;
  isHidden?: boolean;
  wrapperClassName?: string;
};

const LayoutBackground = ({
  children,
  isHidden = true,
  wrapperClassName = "",
}: IProps) => {
  return (
    <div
      className={`${
        isHidden ? "hidden" : ""
      } relative w-1/2 lg:flex ${wrapperClassName}`}
    >
      {/* Gradient + image background */}
      <div className="absolute inset-0 w-full h-full">
        <div className="absolute inset-0 bg-linear-to-r from-primary to-primary" />
        <img
          src={BgPattern}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 object-cover w-full h-full"
        />
      </div>

      {/* Content overlay */}
      <div className="relative z-10 flex flex-col justify-center items-center w-full h-full gap-10 px-6 lg:px-10">
        {children}
      </div>
    </div>
  );
};

export { LayoutBackground };
